<!-- pc端的左侧导航菜单组件-->
<template>
  <ul :class="classObj" ref="menu">
    <li
        v-for="(item, index) in menus"
        :key="index"
        :ref="'li-' + index"
        @mousemove="slideMove(index)"
        @click="jump(index)"
    >
      <router-link :to="item.path">
        <el-tooltip class="item" effect="dark" :disabled="!opening" :content=" item.name" placement="right">
          <i :class="item.icon"></i>
        </el-tooltip>

        <span>{{ item.name }}</span>
      </router-link>
    </li>
    <li
        class="slide"
        ref="slide"
        :style="{ transform: `translateY(${slideTop}px)` }"
        v-show="isShow"
    ></li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      slideTop: 0, //用于记录鼠标实时的移动
      scrollHeight: 0, //用于保存当前菜单的高度
      isMoving: false,
      opening: false
    };
  },
  computed: {
    menus() {
      return this.$store.state.menus;
    },
    activePath() {
      return this.$route.path;
    },
    isShow() {
      if ( this.$route.path == "/welcome" && !this.isMoving ) return false;
      return true;
    },
    classObj() {
      return this.opening ? 'opening menu' : 'menu'
    }
  },
  watch: {
    activePath: {
      handler(latest, older) {
        setTimeout((_) => {
          if (
              (this.slideTop == 0 || this.slideTop == "auto") &&
              latest == "/matters"
          ) {
            this.jump(parseInt(this.$route.query.type) + 1);
          }
        }, 1000);
      },
      immediate: true,
    },
  },
  mounted() {
    this.slideTop = this.scrollHeight = this.$store.state.slideTop || 0;

    const that = this;

    // 在鼠标离开左侧菜单栏时
    this.$refs.menu.onmouseleave = function (e) {
      that.isMoving = false;
      that.slideTop = that.scrollHeight;
    };

    this.$bus.$on('foldMenu', () => {
      this.opening = !this.opening
    })
  },
  methods: {
    // 点击菜单路由链接时触发
    jump(index) {
      this.slideTop = this.scrollHeight =
          this.$refs[`li-${ index }`][0].offsetTop;
      this.$store.commit("SAVEHEIGHT", this.scrollHeight);
    },
    // 鼠标在菜单路由连接时触发
    slideMove(index) {
      this.isMoving = true;
      this.slideTop = this.$refs[`li-${ index }`][0].offsetTop;
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/assets/fonts/iconfont.css';

ul.menu {
  height: 100%;
  width: 236px;
  background: #2b333e;
  position: relative;
  overflow: hidden;
  transition: width .2s;

  li {
    a {
      color: #aeb7c2;
      transition: all 0.3s;
      display: block;
      height: 60px;
      line-height: 60px;
      padding-left: 1.5rem;
      font-size: 0.95rem;
      position: relative;
      letter-spacing: 2px;
      white-space: nowrap;
      word-break: keep-all;

      //统一设定
      i {
        font-size: 1.2rem;
        padding-right: 10px;
        transition: all .3s;

        //个别调整
        &.icon-huanbaochufa {
          font-size: 1.35rem;
        }

        &.icon-gongzuojiancha {
          font-size: 1.1rem;
        }

      }

      &:hover {
        color: #fff;
      }
    }

    .router-link-exact-active {
      color: #fff;
      background: #1e232b;

      i {
        color: #fff;
      }
    }

    &.slide {
      position: absolute;
      left: 0;
      width: 4px;
      height: 60px;
      top: 0;
      background: #00aaff;
      transition: all 0.3s;
    }
  }

  &.opening {
    width: 65px;

    li a i {
      padding-right: 1rem;
      margin-right: .6rem;
    }
  }
}
</style>